import api from './axios';

export const getEmpresas = () =>
  api.get('/empresas').then((r) => r.data);

export const createEmpresa = (data) =>
  api.post('/empresas', data).then((r) => r.data);

export const updateEmpresa = (id, data) =>
  api.patch(`/empresas/${id}`, data).then((r) => r.data);
